// global page analytics object
var pageInfoGlobal = (function () {
    const getPageName = () => {
        const pathName = window.location.pathname;
        let pathNameArray = pathName.split("/");
        pathNameArray = pathNameArray.filter((item) => item !== "");
        if (pathNameArray.includes("a")) {
            pathNameArray.splice(pathNameArray.indexOf("a"), 1);
        }
        return !pathNameArray.length
            ? "monotypefonts:home"
            : `monotypefonts:${pathNameArray.join(":")}`;
    };
    const getPageloadEventInfo = () => {
        const pathName = window.location.pathname;
        if (pathName.includes("cart")) {
            return "cartView";
        } else if (pathName.includes("checkout")) {
            if (Shopify.Checkout.step === "contact_information") {
                return "billingAddress";
            } else if (Shopify.Checkout.step === "payment_method") {
                return "paymentpageLoad";
            } else if (Shopify.Checkout.step === "thank_you") {
                return "orderConfirmation";
            }
        } else if (pathName.includes("additional-information")) {
            return "freeTrialPage";
        } else {
            return "regularPageLoad";
        }
    };
    const getPageSection = () => {
        const pathName = window.location.pathname;
        let pageSection = "";
        if (pathName.includes("thank_you")) {
            pageSection = "purchase";
        } else if (pathName.includes("checkout")) {
            pageSection = "checkout";
        } else if (pathName === "/") {
            pageSection = "home";
        }
        return pageSection;
    };
    const getCurrency = () => {
        const pathName = window.location.pathname;
        let currency = "";
        if (pathName.includes("checkout")) {
            currency = Shopify?.Checkout?.currency;
        } else {
            currency = Shopify?.currency?.active;
        }
        return currency;
    };
    const getCountry = () => {
        const pathName = window.location.pathname;
        let country = "";
        if (pathName.includes("checkout")) {
            country = "";
        } else {
            country = Shopify?.country;
        }
        return country;
    };
    const getWebLanguage  = () => {
        if(Shopify?.locale?.toUpperCase() === "PT-BR" || Shopify?.Checkout?.normalizedLocale?.toUpperCase() === "PT-BR") {
            return "PT";
        }
        return Shopify?.locale?.toUpperCase() || Shopify?.Checkout?.normalizedLocale?.toUpperCase();
    };
    const analyticsObj = {
        pageContent: {
            resourceTitle: "",
            resourceTopic: "",
        },
        hasCustomPageLoad: !!window.location.pathname.includes("search"),
        pageError: {
            errorCode: "",
            errorMessage: "",
            errorType: "",
        },
        pageInfo: {
            event: "pageLoad",
            eventInfo: getPageloadEventInfo(),
            pageName: getPageName(),
            pageSection: getPageSection(),
            pageUrl: window.location.href,
            webCountry: getCountry(),
            webLanguage: getWebLanguage(),
            webCurrency: getCurrency(),
            findingMethod: "null"
        },
    };
    if (typeof customerAnalyticsObj !== "undefined" && customerAnalyticsObj) {
        analyticsObj["userInfo"] = {
            Auth0Id: customerAnalyticsObj.auth0Id,
            userStatus: customerAnalyticsObj ? "Logged In" : "Guest",
            hasMultipleOrganization:
                customerAnalyticsObj.hasMultipleOrganization?.toString(),
            associatedOrgCnt: customerAnalyticsObj.associatedOrgCnt.toString(),
            encryptedUserEmail: (function () {
                //TODO: change to encrypt to email digest
                return btoa(customerAnalyticsObj.email);
            })(),
        };
        analyticsObj["userOrganization"] = {
            companyName: (function () {
                const loggedInOrg = localStorage.getItem("currentCompanyName");
                const loggedInOrgDetail = customerAnalyticsObj.companiesData
                    ? customerAnalyticsObj.companiesData[loggedInOrg]
                    : null;
                return loggedInOrgDetail?.name || "";
            })(),
        };
    }
    if (typeof cartAnalyticsObj !== "undefined" && cartAnalyticsObj) {
        analyticsObj["subplan"] = [].concat(cartAnalyticsObj);
    }
    if (typeof orderTransactionObj !== "undefined" && orderTransactionObj) {
        analyticsObj["txn"] = orderTransactionObj;
    }
    // for page level 400/404 not adding page error object
    if (
        typeof brillioAnalyticsPageError !== "undefined" &&
        brillioAnalyticsPageError
    ) {
        analyticsObj["pageError"] = {
            ...brillioAnalyticsPageError,
        };
    }
    if (
        window.location.pathname.includes("cart") &&
        window.location.href.includes("delay=true")
    ) {
        return null;
    }
    return analyticsObj;
})();

var dispatchCustomEvent;
// global listener and custom event dispatcher for
(function () {
    // global custom event dispatcher
    dispatchCustomEvent = (element, options = undefined) => {
        const customEvent = element.getAttribute("data-custom-event");
        const getCustomEventObj = () => {
            switch (customEvent) {
                case "prodRemove":
                case "checkout":
                    return {
                        event: customEvent,
                        subplan: pageInfoGlobal.subplan,
                    };
                default:
                    return {
                        event: customEvent ?? "linkClick",
                        ...options,
                    };
            }
        };
        console.log(
            "custom event obj =========== ",
            JSON.stringify(getCustomEventObj())
        );
        const customEventObj = new CustomEvent("customAnalyticsEvent", {
            detail: getCustomEventObj(),
            bubbles: true,
            cancelable: true,
        });
        document.dispatchEvent(customEventObj);
    };
    // global click listener
    document.addEventListener("click", function (e) {
        const element = e.target;
        try {
            if (
                (element.id === "checkout_submit" ||
                    element.parentElement?.id === "checkout_submit") &&
                Shopify.Checkout.step === "payment_method"
            ) {
                const elDiscount = document.querySelector(
                    '.sidebar button[name="checkout[submit]"]'
                );
                const isDisabled = !!elDiscount.getAttribute("disabled");
                if (isDisabled) return;
                dispatchCustomEvent(elDiscount, {
                    links: {
                        linkCategory: "coupon code",
                        linkSection: "payment method",
                        linkName: "coupon code apply",
                        linkType: "button",
                    },
                });
                setTimeout(() => {
                    const el = document.getElementById(
                        "checkout_reduction_code"
                    );
                    const appliedDiscountEl =
                        document.querySelector(".reduction-code");
                    const parentEl =
                        el.parentElement?.parentElement?.parentElement;
                    if (parentEl.classList.contains("field--error")) {
                        dispatchCustomEvent(elDiscount, {
                            links: {
                                linkCategory: "coupon code",
                                linkSection: "payment method",
                                linkName: "coupon code failed",
                                linkType: "button",
                            },
                        });
                    } else if (appliedDiscountEl) {
                        dispatchCustomEvent(elDiscount, {
                            links: {
                                linkCategory: "coupon code",
                                linkSection: "payment method",
                                linkName: "coupon code successfully applied",
                                linkType: "button",
                            },
                        });
                    }
                }, 3000);
            }
            if (element.tagName === "use" || element.tagName === "svg") return;
            if (element.hasAttribute("data-custom-event")) {
                dispatchCustomEvent(element, getAnalyticsOptions(element));
            } else if (
                element.className?.includes("l-header-text") ||
                element.className?.includes("cart-summary-login-button")
            ) {
                element.setAttribute("data-custom-event", "loginIntent");
                dispatchCustomEvent(element, getAnalyticsOptions(element));
            } else if (
                element.id === "evg-hero-cta-button" ||
                element.id === "evg-hero-cta-button2" ||
                element.className?.includes("notification-icon-mtf")
            ) {
                element.setAttribute("data-custom-event", "linkClick");
                dispatchCustomEvent(element, getAnalyticsOptions(element));
            } else if (element.className?.includes("privy-button-element")) {
                element.setAttribute(
                    "data-custom-event",
                    "newslatterSubscribe"
                );
                dispatchCustomEvent(element, getAnalyticsOptions(element));
            }
        } catch (err) {
            console.error(err);
        }
    });
    // global attribute setter
    document.addEventListener("DOMContentLoaded", function (e) {
        const element = e.target;
        if (Shopify.Checkout) {
            // setup checkout page attributes
            if (Shopify.Checkout.step == "payment_method") {
                const elReturnToInfoTop = document.querySelector(
                    ".main__header>nav ol li:nth-child(2)>a"
                );
                const elReturnToInfoBottom = document.querySelector(
                    ".step__footer__previous-link"
                );
                const salesBtn = document.querySelector(".step__footer>span>a");
                const elPayNow = document.getElementsByClassName(
                    "step__footer__continue-btn"
                );
                setAnalyticsAttribute(elReturnToInfoTop, {
                    linkCategory: "payment method page",
                    linkSection: "payment method page",
                    linkName: "return to information",
                    linkType: "button",
                });
                setAnalyticsAttribute(elReturnToInfoBottom, {
                    linkCategory: "payment method page",
                    linkSection: "payment method page",
                    linkName: "return to information",
                    linkType: "button",
                });
                setAnalyticsAttribute(salesBtn, {
                    linkCategory: "payment method page",
                    linkSection: "payment method page",
                    linkName: "talk to sales",
                    linkType: "button",
                });
                Array.from(elPayNow).forEach((el) => {
                    setAnalyticsAttribute(el, {
                        linkCategory: "payment method",
                        linkSection: "payment method page",
                        linkName: "Pay now",
                        linkType: "button",
                    });
                });
            } else if (Shopify.Checkout.step === "contact_information") {
                const elCntBtn = document.querySelector("#continue_button");
                const logoutEl = document.querySelector(
                    '.logged-in-customer-information a[href*="logout"]'
                );

                setAnalyticsAttribute(elCntBtn, {
                    linkCategory: "billingAddress",
                    linkSection: "edit_checkout",
                    linkName: "Continue to payment",
                    linkType: "button",
                });
                setAnalyticsAttribute(logoutEl, {
                    linkCategory: "billingAddress",
                    linkSection: "edit_checkout",
                    linkName: "logout",
                    linkType: "button",
                });
            }
        } else {
            const planPageFAQ = document.querySelector(
                '.marketo-embed-code a[href*="font-management-faq'
            );
            setAnalyticsAttribute(planPageFAQ, {
                linkCategory: "faq",
                linkSection: "plans page",
                linkName: "read all faqs",
                linkType: "button",
            });
        }
    });
    // 404/400 page error
    if (
        typeof brillioAnalyticsPageError !== "undefined" &&
        brillioAnalyticsPageError
    ) {
        document.body.setAttribute("data-custom-event", "error");
        dispatchCustomEvent(document.body, {
            pageError: {
                ...brillioAnalyticsPageError,
            },
        });
    }
})();

// global intersection observers
(function () {
    const handleInterSectionCallback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const options = getPopupAnalyticsOptions(element);
                if (options) {
                    element.setAttribute("data-custom-event", "overlayLoad");
                    dispatchCustomEvent(element, options);
                }
            }
        });
    };
    window.addEventListener("load", function () {
        const observer = new IntersectionObserver(handleInterSectionCallback);
        // root popup
        // loader_pop-up
        // cart_verification_step_pop-up
        const cartPopUpTargets = document.querySelectorAll(
            'div[id="cart_verification_step_pop-up"] > .tabcontent'
        );
        const expiredTrialPopUpTarget = document.getElementById(
            "expired_trial_pop-up"
        );
        const resendEmailPopUpTarget = document.getElementById(
            "resend_email_pop-up"
        );
        const resendEmailAgainPopUpTarget = document.getElementById(
            "resend_email_again_pop-up"
        );
        const emailVerifiedFalsePopUpTarget = document.getElementById(
            "email_verified_false_pop-up"
        );
        const accountCreationDelayedAtEnterpriseTarget =
            document.getElementById("creating_account_pop-up");
        const cartNotAllowedPopUpTarget = document.getElementById(
            "cart_not_allowed_pop-up"
        );
        // cart_not_allowed_pop-up

        const finalPopUpTargets = [
            ...cartPopUpTargets,
            expiredTrialPopUpTarget,
            resendEmailPopUpTarget,
            resendEmailAgainPopUpTarget,
            emailVerifiedFalsePopUpTarget,
            accountCreationDelayedAtEnterpriseTarget,
            cartNotAllowedPopUpTarget,
        ];

        for (const el of finalPopUpTargets) {
            if (el) {
                observer.observe(el);
            }
        }
    });
})();

function getPopupAnalyticsOptions(element) {
    if (element.id === "cartVerifyEmail") {
        return {
            content: {
                overlayName: "Verify email",
            },
        };
    } else if (element.id === "cartLicenseAgreement") {
        return {
            content: {
                overlayName: "Verify license",
            },
        };
    } else if (element.id === "cartAccountInfo") {
        return {
            content: {
                overlayName: "Account Info",
            },
        };
    } else if (element.id === "expired_trial_pop-up") {
        return {
            content: {
                overlayName: "Expired trial",
            },
        };
    } else if (element.id === "resend_email_pop-up") {
        return {
            content: {
                overlayName: "Resend email",
            },
        };
    } else if (element.id === "resend_email_again_pop-up") {
        return {
            content: {
                overlayName: "Resend email again",
            },
        };
    } else if (element.id === "email_verified_false_pop-up") {
        return {
            content: {
                overlayName: "Email verified false",
            },
        };
    } else if (element.id === "creating_account_pop-up") {
        return {
            content: {
                overlayName: "Account creation delayed at enterprise",
            },
        };
    } else if (element.id === "cart_not_allowed_pop-up") {
        return {
            content: {
                overlayName: "cart not allowed",
            },
        };
    }
}

function getAnalyticsOptions(element) {
    if (element.id.includes("evg-hero-cta-button")) {
        return {
            links: {
                linkCategory: "Hero Banner",
                linkSection: "top-animation",
                linkName: element.innerText.strip(),
                linkType: "a",
            },
        };
    } else if (element.className?.includes("notification-icon-mtf")) {
        return {
            links: {
                linkCategory: "header",
                linkSection: "primary header",
                linkName: "notification",
                linkType: "icon",
            },
        };
    } else if (element.className.includes("privy-button-element")) {
        return {
            links: {
                linkCategory: "newslatter",
                linkSection: "privy",
                linkName: "subscribe",
                linkType: "button",
            },
        };
    } else if (element.id === "start-free-trial-cta") {
        return {
            links: {
                linkCategory: "header",
                linkSection: "navigation bar",
                linkName: "start free trial",
                linkType: "navigation",
            },
        };
    } else if (element.id === "sftrial") {
        const consentEl = document.getElementById("consent");
        return {
            links: {
                linkCategory: "free trial form ",
                linkSection: "free trial form ",
                linkName: "start my free trial",
                linkType: "button",
                emailCheckBox: consentEl.checked ? "enable" : "disable",
            },
        };
    } else if (element.id === "cart-consent-close") {
        return {
            links: {
                linkCategory: "overlay",
                linkSection: "pop-up-block",
                linkName: "close license overlay",
                linkType: "button",
            },
            content: {
                overlay: "license overlay",
            },
        };
    } else if (element.className.includes("l-header-text")) {
        return {
            links: {
                linkCategory: "header",
                linkSection: "primary header",
                linkName: "login",
                linkType: "icon",
            },
        };
    } else if (element.className.includes("cart-summary-login-button")) {
        return {
            links: {
                linkCategory: element.getAttribute("data-custom-linkCategory") || "cart page",
                linkSection: element.getAttribute("data-custom-linkSection") || "cart summary",
                linkName: element.getAttribute("data-custom-linkName") || "login",
                linkType: element.getAttribute("data-custom-linkType") || "button",
            },
        };
    } else if (
        element.tagName === "A" ||
        element.tagName === "BUTTON" ||
        element.tagName === "SPAN" ||
        element.tagName === "DIV"
    ) {
        return {
            links: {
                linkCategory: element.getAttribute("data-custom-linkCategory"),
                linkSection: element.getAttribute("data-custom-linkSection"),
                linkName: element.getAttribute("data-custom-linkName"),
                linkType: element.getAttribute("data-custom-linkType"),
            },
        };
    }
}

function setAnalyticsAttribute(element, options) {
    if (!element) {
        console.log("no element found for analytics attribute");
        return;
    }
    Object.keys(options).map((key) => {
        element.setAttribute(`data-analytics-${key}`, options[key]);
    });
}
